import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import MDTypography from "../../../../../components/MDTypography";
import MDBox from "../../../../../components/MDBox";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

interface SegmentationControlsProps {
  count: number;
  maxCount: number;
  onAdd: () => void;
  onRemove: () => void;
  canRemove: boolean;
}

const SegmentationControls: React.FC<SegmentationControlsProps> = ({ count, maxCount, onAdd, onRemove, canRemove }) => {
  return (
    <MDBox display="flex" justifyContent="center" alignItems="center" mt={1}>
      <IconButton
        size="small"
        color="primary"
        onClick={onRemove}
        disabled={!canRemove}
        sx={{ border: "1px solid", borderRadius: "4px", padding: "1px" }}
      >
        <Tooltip title="Remove last segmentation">
          <RemoveIcon fontSize="small" />
        </Tooltip>
      </IconButton>

      <MDTypography variant="body2" mx={1.5}>
        {count}
      </MDTypography>

      <IconButton
        size="small"
        color="primary"
        onClick={onAdd}
        disabled={count >= maxCount}
        sx={{ border: "1px solid", borderRadius: "4px", padding: "1px" }}
      >
        <Tooltip title="Add new segmentation">
          <AddIcon fontSize="small" />
        </Tooltip>
      </IconButton>
    </MDBox>
  );
};

export default SegmentationControls;
